export default () => ({
  items: [],
  pagination: [],
  item: {},
  share: {}
})
